export default __webpack_public_path__ + "static/image6-36d6367d6a08b07454823e8b43326a4f.jpeg";